export enum AccountType {
  SAVINGS_ACCOUNT = 'Savings account',
  CHECKING_ACCOUNT = 'Checking account',
  OTHER = 'Other',
}
